import React, {useState, useEffect} from 'react';
import {FaBars} from 'react-icons/fa';
import Logo from '../../../images/logo.png';
import {Nav, NavbarContainer, NavLogo, NavMenu, NavItem, NavLinks, MobileIcon, NavBtn, NavBtnLink} 
    from './NavbarElements';
import {animateScroll as scroll} from 'react-scroll';

const TeamNavbar = ({toggle}) => {

    const [scrollNav, setScrollNav] = useState(false)

    const changeNav = ()=> {
        if(window.scrollY >= 80) {
            setScrollNav(true)
        } else {
            setScrollNav(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav)
    }, [])

    const toggleHome = () => {
        scroll.scrollToTop();
    };

    return (
        <>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavLogo to='/' onClick={toggleHome}>
                        <img src={Logo} alt="Logo" style={{ width: '50px', padding: '5px',}}></img>
                        UQ Fintech 
                    </NavLogo>
                    <MobileIcon onClick={toggle}>
                        <FaBars />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to='about us' smooth="true" exact="true" offset={-80} >
                                About Us
                            </NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to='our team' smooth="true" exact="true" offset={-80} >
                                Our Team
                            </NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to='history' smooth="true" exact="true" offset={-80} >
                                History
                            </NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavBtn>
                        <NavBtnLink to="/signin" smooth="true" exact="true" offset={-80} >
                            Sign In
                        </NavBtnLink>
                    </NavBtn>
                </NavbarContainer>
            </Nav>
        </>
    );
};

export default TeamNavbar